import {SET_RCM_PRODUCT_BADGES_PICKS, SET_RCM_PRODUCT_BADGES_RECOMMENDATIONS} from "../store/mutation-types";
import {store} from "../store";
const shownBadgeRecommendations = [];
export const updateProductsWithRcmBadge = ({selfObj, products}) => {
	if (!selfObj.$store.getters.featureToggles.enableRcmProductBadges) return;
	const badges = selfObj.$store.getters.rcmProductBadges
		&& selfObj.$store.getters.rcmProductBadges.recommendations;

	if (badges) {
		for (const badge of badges) {
			const foundItem = (products || []).find(x => x.id === badge.productId && !(x.options.label && x.options.label.isActive));

			if (foundItem) {
				foundItem.options.label = {
					badgeId: badge.badgeId,
					experimentId: badge.experimentId,
					text: badge.labelText,
					labelRef: badge.labelRef,
					active: true,
					type: "RCM"
				};
				if(shownBadgeRecommendations.findIndex(r => r.itemNumber === foundItem.id) === -1) {
					shownBadgeRecommendations.push({
						itemNumber: foundItem.id,
						badgeId: badge.badgeId,
						type: badge.type
					});
				}
			}
		}
		if(shownBadgeRecommendations.length) {
			selfObj.$store.commit(SET_RCM_PRODUCT_BADGES_RECOMMENDATIONS, {
				experimentId: selfObj.$store.getters.rcmProductBadges.experimentId,
				recommendations: shownBadgeRecommendations
			});
		}
	}
};

export const savePickedBadge = (item) => {
	if(item.product.options.label && item.product.options.label.type === "RCM") {
		const pickedBadgeItem = {
			itemNumber: item.product.id,
			badgeId: item.product.options.label.badgeId,
			type: "RCM"
		};
		store.commit(SET_RCM_PRODUCT_BADGES_PICKS, pickedBadgeItem);
	}
};
